import { Component, inject, Input, OnDestroy, OnInit } from "@angular/core";
import { Subscription } from "rxjs";
import { RouterLink } from "@angular/router";
import { QlikService } from "../../felles/services/qlik.service";

@Component({
  selector: "stat-forsidelenke",
  templateUrl: "./forsidelenke.component.html",
  imports: [RouterLink],
})
export class ForsidelenkeComponent implements OnInit, OnDestroy {
  @Input() kpiId: string;
  @Input() farge: string;
  @Input() tittel: string;
  @Input() url: string;
  @Input() query: object;

  kpi = null;
  collector: Subscription = new Subscription();

  qlikService = inject(QlikService);

  ngOnInit() {
    this.qlikService
      .getKpi(this.kpiId)
      .subscribe(result => {
        this.kpi = result;
      })
      .add(this.collector);
  }

  ngOnDestroy() {
    this.qlikService.destroyKpi(this.kpiId);
    this.collector.unsubscribe();
  }
}
